import './App.css';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Admin from './containers/Admin/Admin';
import Login from './containers/Login/Login';
import LoginAuth from './components/LoginAuthComponent/LoginAuth';
import TeamDirectory from './components/Teamdirectory';
import Feedback from './components/Feedback';
import AddressDetail from './components/AddressForm';
import BankDetails from './components/BankDetailsForm';
import EducationDetail from './components/EducationDetailForm';
import CertificateDetails from './components/CertificateDetailForm';
import ProfileContainer from './components/ProfileContainer';
import Profile from './components/Profile';
import PassportDetail from './components/PassportForm';
import PreviousEmploymentDetails from './components/PreviousEmploymentForm';
import SkillDetails from './components/SkillsForm';
import DependentDetails from './components/DependentForm';
import EmployeeInfo from './components/EmployeeInfo';
import FeedbackGrid from './components/FeedbackGrid';
import AddFeedback from './components/AddFeedbackForm';
import HrApproveFeedback from './components/HrApproveFeedbackForm';
import SalaryRevisionGrid from './components/SalaryRevisionGrid';
import OnboardingDetails from './components/OnboardingGrid';
import SalaryRevision from './components/SalaryRevisionForm';
import OffboardingGrid from './components/OffboardingGrid';
import GoalTemplateForm from './containers/ManageGoalTemplate/GoalTemplateForm';
import TemplateData from './containers/ManageGoalTemplate/ManageGoalTemplate';
import NavHeader from './components/NavHeader/NavHeader';
import MoodGrid from './components/MoodGridComponent';
import Overview from './containers/overview/Overview';
import TeamMemberDashboard from './containers/teammember dashboard/TeamMemberDashboard';
import HRDisagreeFeedback from './components/HrDisagreeFeedback';
import EmpDisagreeFeedback from './components/EmpDisagreeFeedback';
import IndivigualFlagFeedbackGrid from './components/IndivigualFlagFeedbackGrid';
import ProfileFeedbackTabGrid from './components/ProfileFeedbackTab';
import { CandidateOverview } from './components/candidateOverview';
import { JobPosting } from './components/jobPostingComponent';
import { JobInformation } from './components/jobInformation';
import { JobsLanding } from './components/jobsLanding';
import Onboarding from './components/Onboarding';
import { useEffect, useState, useRef } from 'react';
import { ConcernsGrid } from './components/Concerns/ConcernsGrid';

import ConcernForm from './components/Concerns/ConcernsForm';
import ConcernView from './components/Concerns/ConcernView';
import { FAQList } from './components/FAQs/FAQList';
import { FAQForm } from './components/FAQs/FAQForm';
import Todo from './containers/Todo/Todo';
import Appreciation from './containers/Appreciation/Appreciation';
import AppreciationForm from './containers/Appreciation/AppreciationForm';
import ProfileUpdate from './containers/ProfileRequest/ProfileRequest';

import PolicyDirectory from './/containers/PolicyDirectory';
import IndividualPolicyDirectory from './containers/IndividualPolicyDirectory';
import ManagePolicy from './containers/Policy/ManagePolicy';
import FormPolicy from './containers/Policy/FormPolicy';
import Policy from './containers/Policy/Policy';
import PolicyForm from './containers/Policy/PolicyForm';
import TouchbaseForm from './containers/Touchbase/TouchbaseForm';
import Touchbase from './containers/Touchbase/Touchbase';
import TouchbaseFeedbackForm from './containers/Touchbase/TouchbaseFeedbackForm';
import Performance from './containers/Goals/Performance';
import GoalForm from './components/GoalForm';
import GoalView from './components/GoalView';
import Wfh from './containers/WFH/Wfh';
import WfhForm from './containers/WFH/WfhForm';
import logo from './logo.svg';
import Offboarding from './components/offboarding';
import { HrOffboardingGrid } from './components/HrOffboardGrid';
import HiringProcess from './components/HiringProcess';
import AnnouncementBlog from './components/AnnouncementBlogComponent';
import LeaveForm from './containers/WFH/LeaveForm';
import AppreciationBlog from './components/AppriciationBlogComponent';
import HolidayList from './components/HolidayList/HolidayList';
import moment from 'moment';
import $ from 'jquery';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import { UserContext } from './constant';
import OfferLetter from './components/OfferLetter';
import Footer from './components/Footer/Footer';
import { setWekSocket } from './Redux/Notification/NotificationAction';
import NotificationCall from './components/NotificationCall';
import { connect } from 'react-redux';
import ErrorPage from './StaticComponent/404/404';
import PerformanceEvaluation from './containers/PerformanceEvaluation/PerformanceEvaluation';

import hiveLogo from './hive.svg';


import { encryptStorage } from './constant';
import { useJwt } from 'react-jwt';
import { getLogin, getRefreshToken } from './service/adminApi';
import Grid from './containers/Centcom';
import { approverRibbon, userRibbon } from './service/todo';
import { getS3 } from './utils/Download';
import Sign from './components/AddSignature/sign'
import { SessionOverview } from './components/SoftSkills/SessionOverview';
import { SessionParticipants } from './components/SoftSkills/SessionParticipants';
import AdminCertifications from './components/Certifications/AdminCertifications';
import CertificationList from './components/Certifications/CertificationsList';
import EmployeeCertifications from './components/Certifications/EmployeeCertification';
import FinanceManagement from './components/Certifications/FinanceManagement';

function App({ setWebSocket, websocketAPI }) {
    let navLocate = useLocation();
    let navloc = navLocate?.state?.hideNav;
    let websocket;
    const [socketId, setsocketId] = useState(0);
    const navigate = useNavigate();
    let token = encryptStorage.getItem('jwtToken');
    const { isExpired } = useJwt(token);
    const [centcomManageRole, setCentcomManageRole] = useState('');
    ////PC_FG_83
    const [ribbon, setRibbon] = useState([]);
    const [currentRibbon, setCurrentRibbon] = useState(0);
    const [freeze, setFreeze] = useState(0);
    const [viewPopup, setViewPopup] = useState();
    const forceUpdateRef = useRef(null);
    const [policyaction, setpolicyaction] = useState();
    const [timeoutPopup, setTimeoutPopup] = useState(false);
    const TIMEOUT_DURATION = 1800000; // 30 minutes in milliseconds
    const timeoutIdRef = useRef(null);
    const location = useLocation();
    const isLoginPage = location.pathname === '/' || location.pathname === '/hivelogin';
     const isRouteNotEmpty = navLocate.pathname == '/';
     useEffect(()=>{
        if (encryptStorage.getItem('employeeId')){
            
             if (!isRouteNotEmpty) {
                getUserRibbon();
            }
        }
    }, []);
    useEffect(() => {
        const startTimer = () => {
          if (!isLoginPage && !timeoutPopup) {
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(() => {
              setTimeoutPopup(true);
              sessionStorage.setItem('sessionTimedOut', 'true'); // Set sessionTimedOut in sessionStorage
            }, TIMEOUT_DURATION);
          }
        };
   
        const resetTimeoutTimer = () => {
          clearTimeout(timeoutIdRef.current);
          startTimer();
        };
   
        window.addEventListener('mousemove', resetTimeoutTimer);
        window.addEventListener('keydown', resetTimeoutTimer);
        window.addEventListener('click', resetTimeoutTimer);
        window.addEventListener('scroll', resetTimeoutTimer);
   
        // Check sessionTimedOut status on page load
        const sessionTimedOut = sessionStorage.getItem('sessionTimedOut');
        if (sessionTimedOut === 'true' && !isLoginPage) {
            encryptStorage.clear();
            sessionStorage.clear();
            window.location.href = '/';
        }
   
        // Cleanup event listeners on component unmount
        return () => {
          clearTimeout(timeoutIdRef.current);
          window.removeEventListener('mousemove', resetTimeoutTimer);
          window.removeEventListener('keydown', resetTimeoutTimer);
          window.removeEventListener('click', resetTimeoutTimer);
          window.removeEventListener('scroll', resetTimeoutTimer);
        };
      }, [isLoginPage]);
      const handleLogout = () => {
        sessionStorage.clear();
        encryptStorage.clear();
        window.location.href = '/';
      };
    useEffect(() => {
        let verifyJwt = isExpired;
        // if (!isExpired) {
        //     alert("expired");
        //     encryptStorage.clear();
        //     navigate('/')
        // }
        // if (!encryptStorage.getItem('employeeId') || !encryptStorage.getItem('jwtToken')) {
        //    navigate('/', { state: { hideNav: false } });
        // }
        //PC_FG_83
        // if (encryptStorage.getItem('employeeId')) getUserRibbon();
        getSocket(encryptStorage.getItem('employeeId'));
        setCentcomManageRole(encryptStorage.getItem('groupid'));

        window.Notification.requestPermission();
    }, [socketId]);

    // useEffect(() => {
    // //     // Display modal popup when ribbon data is fetched
    // //     if (ribbon.length > 0) {
    //         viewPolicy()
    // //     }
    // }, []);

    const generateToken = async () => {
        



        if (encryptStorage.getItem('refresh') && encryptStorage.getItem('refresh') != 'undefined') {
            let refresh_token = encryptStorage.getItem('refresh')
            let admindata = {
                modulename: 10,
                methodname: 4,
                payload: { refresh_token },
                // private_key: PRIVATE_KEY,
            };

            let adminvalue = await getRefreshToken(admindata);

            encryptStorage.setItem('token', adminvalue.data.ResponseData?.access_token);
            encryptStorage.setItem('refresh', adminvalue.data.ResponseData?.refresh_token);
        }
        // Your token generation logic here
    };

    //PC_FG_83
    async function getUserRibbon() {
        try {
            //PC_FG_84
            let response1 = await userRibbon({ employeeId: encryptStorage.getItem('employeeId') });
            let userribbonres = response1?.data[0]?.created_at;

            //PC_FG_85
            let response = [];
            let enduserAction=""
            //PC_FG_86
            if (encryptStorage.getItem('secAudits')) {
                //PC_FG_87
                response = await approverRibbon({ emp_id: 'Sec Audits' });
                enduserAction = response?.data[0]?.created_at;
            }
            //PC_FG_88
            else if (encryptStorage.getItem('groupid') == 1) {
                response = await approverRibbon({ emp_id: encryptStorage.getItem('employeeId') });
                enduserAction = response?.data[0]?.created_at;
            }
            //PC_FG_89
            let value1 = [];
            //PC_FG_90
            response?.data?.map((value, index) => {
                value1.push({
                    name: `to Approve the ${value?.policy_name}`,
                    // date:value.previous_modified ? value.previous_modified : value.created_at,
                    date: calculateRemainingDays(value.previous_modified_at ? value.previous_modified_at : value.created_at),
                    policyURL: getS3(value?.policy_url),
                    id: value?.policy_id,
                    type: 'approver',
                    nameForParams: value?.policy_name,
                    originialURl: value?.policy_url,
                });
            });
            //PC_FG_91
            response1?.data?.map((value, index) => {
                value1.push({
                    name: `to Sign the ${value?.policy_name}`,
                    // date:value.previous_modified ? value.previous_modified : value.created_at,
                    date: calculateRemainingDays(value.created_at),
                    signature: value?.signature_required,
                    id: value?.policy_id,
                    policyURL: getS3(value?.policy_url),
                    type: "user",
                    nameForParams: value?.policy_name,
                    originialURl: value?.policy_url,
                });
            });
            //PC_FG_92
            setRibbon(value1);
            let valuesWithZero = value1.filter(obj => obj.date === 0);
            setFreeze(valuesWithZero);
            if (userribbonres && enduserAction) {
                if (userribbonres > enduserAction) {
                    setpolicyaction('acknowledge');
                } else setpolicyaction('be approved');
            } else if (!userribbonres && enduserAction) {
                setpolicyaction('be approved');
            } else if (userribbonres && !enduserAction) {
                setpolicyaction('acknowledge');
            }
        } catch (error) {
            console.log(error.message, 'error');
        }
    }

    //PC_FG_108
    function calculateRemainingDays(timestamp) {
        // Convert the timestamp to a Date object PC_FG_109
        let date = new Date(timestamp);

        // Add three days to the given timestamp PC_FG_110
        //date.setTime(date.getTime() + (6 * 60 * 60 * 1000)); // Add 6 hours
        date.setDate(date.getDate() + 3); // Add three days after adding 6 hours

        //PC_FG_111 Calculate the number of days remaining excluding Saturdays and Sundays
        let remainingDays = 0;
        let currentDate = new Date();

        // PC_FG_112
        while (currentDate < date) {
            //PC_FG_113 Check if the current day is not Saturday or Sunday
            remainingDays++;
            //PC_FG_115
            currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
        }
        //PC_FG_116
        return remainingDays;
    }
    //PC_FG_93,94
    function ribbonAlert() {
        return (
            <>
                {/* PC_FG_96 */}
                <div
                    style={{ paddingTop: '3%' }}
                    className="alert-policy d-flex align-items-center justify-content-between semibold-text font-14 mt-3"
                >
                    {/* PC_FG_97 */}
                    <div>
                        {/* PC_FG_98,99 */}
                        <img src="Images/Policy/time-icon.svg" class="me-3" alt="time-icon" />
                        {`You have only ${ribbon[currentRibbon]?.date} days ${ribbon[currentRibbon]?.name} `}
                        {/* PC_FG_100 */}
                        <a class="text-white" href="/policy">
                            {' '}
                            Click here
                        </a>
                    </div>
                    {/* PC_FG_101 */}
                    <div>
                        {/* PC_FG_102 */}
                        {currentRibbon > 0 ? (
                            //PC_FG_103
                            <span
                                class="cursor-pointer me-2"
                                onClick={() => {
                                    setCurrentRibbon(currentRibbon - 1);
                                }}
                            >
                                <img src="/Images/Policy/alert-left-arr.svg" alt="alert-left-arr" />
                            </span>
                        ) : (
                            <span class="cursor-pointer me-2">
                                <img src="/Images/Policy/alert-left-arr.svg" alt="alert-left-arr" />
                            </span>
                        )}
                        {/* //PC_FG_104 */}
                        {currentRibbon + 1} of {ribbon.length}
                        {/* //PC_FG_105 */}
                        {currentRibbon + 1 != ribbon.length ? (
                            //PC_FG_106
                            <span class="cursor-pointer ms-2">
                                <img
                                    src="/Images/Policy/alert-right-arr.svg"
                                    alt="alert-left-arr"
                                    onClick={() => {
                                        setCurrentRibbon(currentRibbon + 1);
                                    }}
                                />
                            </span>
                        ) : (
                            <span class="cursor-pointer ms-2">
                                <img src="/Images/Policy/alert-right-arr.svg" alt="alert-left-arr" />
                            </span>
                        )}
                    </div>
                </div>
            </>
        );
    }

    function viewPolicy() {
        
        return (
            <>
                {encryptStorage.getItem('popupShown') == 'false' ? (
                    <></>
                ) : (
                    <>
                        <div className="modal-overlay"></div>
                        <div
                            className="modal fade show"
                            id="viewPolicy"
                            tabIndex={-1}
                            aria-hidden="true"
                            style={{ display: 'block' }}
                            aria-modal="true"
                            role="dialog"
                        >
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body text-center mt-3 px-5">
                                        <div className="w-100 d-flex justify-content-end position-relative">
                                            <button
                                                type="button"
                                                className="btn-close position-absolute "
                                                style={{ top: '-18px', right: '-32px' }}
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                                onClick={() => {
                                                    encryptStorage.setItem('popupShown', false);
                                                    setViewPopup(false);
                                                }}
                                            />
                                        </div>
                                        <div className="d-flex justify-content-center mb-3">
                                            <img src="Images/Policy/view-Policy.svg" alt="view-policy" />
                                        </div>
                                        {/* { (encryptStorage.getItem('secAudits') || (encryptStorage.getItem('groupid') == 1)
                                        //    ||encryptStorage.getItem('grc')
                                        )? */}

                                        {/* (<> */}
                                        <span className="regular-text font-15 mb-2 text-black">
                                            You have certain policies to {policyaction}. Click on ‘View Policies’ to {policyaction}.
                                        </span>
                                        {/* </> */}
                                        {/* ):(<><span className="regular-text font-15 mb-2 text-black">You have certain policies to acknowledge. Click on
                                                ‘View Policies’ to acknowledge.</span></>) */}
                                        {/* } */}
                                        {/* <span className="regular-text font-15 mb-2 text-black">You have certain policies to be approved. Click on
                                                ‘View Policies’ to be approved.</span> */}
                                        </div>
                                        <div className="modal-footer border-0 d-flex justify-content-center">
                                            <button type="button" className="btn hive-btn-primary d-inline font-13 font-semibold px-4 mb-4" onClick={() => {
                                                
                                                encryptStorage.setItem('popupShown', false)
                                                navigate('/policy');
                                                setViewPopup(false);
                                            }}
                                        >
                                            View Policies
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }

    // useEffect hook to run the token generation function initially and then every 30 minutes
    useEffect(() => {
        // Generate token initially when the component mounts
        generateToken();

        // Set interval to generate token every 30 minutes (30 * 60 * 1000 milliseconds)
        const intervalId = setInterval(
            () => {
                generateToken();
            },
            40 * 60 * 1000
        );

        // Clear interval on component unmount to prevent memory leaks
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    async function getSocket(empId) {
        //;
        websocket = new W3CWebSocket('wss://1g9zci5yx6.execute-api.ap-south-1.amazonaws.com/production/');
        // websocket = new W3CWebSocket('wss://yqwcjol1a3.execute-api.us-east-2.amazonaws.com/Nonproduction/');

        setWebSocket(websocket);
        websocket.onopen = () => {
            let empId = encryptStorage.getItem('employeeId');

            websocket.send(
                JSON.stringify({
                    type: 'string',
                    action: 'SetName',
                    empId: empId,
                })
            );
        };
        websocket.onmessage = (message) => {
            //
            let Body = JSON.parse(message.data);
            if (Body.msg && Body.msg.content && Body.msg.content !== 'private message') {
                // $('#notificationDot').addClass('badge-custom2 bg-danger rounded-circle');
                checkPageStatus(Body.msg.content, Body.msg.from);
            }
        };

        websocket.onclose = () => {
            setsocketId(socketId + 1);
        };
    }

    const handleTabClose = (event) => {
        websocketAPI.send(
            JSON.stringify({
                type: 'string',
                action: 'disconnect',
            })
        );
    };
    window.addEventListener('beforeunload', handleTabClose);

    return (
        <div className="container-fluid mb-5">
            {freeze[0]?.date == 0 ? (
                <Sign
                    doc={freeze[0]?.policyURL}
                    End={() => {
                        window.location.reload();
                    }}
                    userType={freeze[0]?.type}
                    sign={freeze[0]?.signature}
                    policyId={freeze[0]?.id}
                    preSignedURL={freeze[0]?.originialURl}
                    policyname={freeze[0]?.nameForParams}
                    freeze={true}
                    view={false}
                ></Sign>
            ) : (
                <div className="row ">
                    {window.location.pathname !== '/' &&
                    window.location.pathname !== '/hivelogin' &&
                    window.location.pathname !== '*' &&
                    navloc == undefined ? (
                        <NavHeader />
                    ) : null}
                    {/* alert starts here */}

                    {/* {ribbon.length>0 ?
                        ribbonAlert() : <></>} */}
                    {ribbon.length > 0 ? (
                        <>
                            {ribbonAlert()}
                            {/* if(encryptStorage.getItem) */}
                            {/* {viewPolicy()} */}
                        </>
                    ) : null}

                    {encryptStorage.getItem('popupShown') !== false && ribbon.length > 0 ? <>{viewPolicy()}</> : null}

                    {/* alert ends here */}
                    <Routes>
                        <Route exact path="/" element={<Login />} />
                        <Route exact path="/hivelogin" element={<LoginAuth />} />
                        <Route exact path="/admin/*" element={<Admin />} />
                        <Route exact path="/Offboard" element={<HrOffboardingGrid />} />
                        <Route exact path="/TeamDirectory" element={<TeamDirectory />} />
                        <Route exact path="/ProfileContainer" element={<ProfileContainer />} />
                        <Route exact path="/Profile" element={<Profile />} />
                        <Route exact path="/AddressDetail" element={<AddressDetail />} />
                        <Route exact path="/EducationDetail" element={<EducationDetail />} />
                        <Route exact path="/CertificateDetails" element={<CertificateDetails />} />
                        <Route exact path="/BankDetails" element={<BankDetails />} />
                        <Route exact path="/PassportDetail" element={<PassportDetail />} />
                        <Route exact path="/PreviousEmploymentDetails" element={<PreviousEmploymentDetails />} />
                        <Route exact path="/SkillDetails" element={<SkillDetails />} />
                        <Route exact path="/DependentDetails" element={<DependentDetails />} />
                        <Route exact path="/EmployeeInfo" element={<EmployeeInfo />} />
                        <Route exact path="/SalaryRevisionGrid" element={<SalaryRevisionGrid />} />
                        <Route exact path="/OnboardingDetails" element={<OnboardingDetails />} />
                        <Route exact path="/SalaryRevision" element={<SalaryRevision />} />
                        <Route exact path="/OffboardingGrid" element={<OffboardingGrid />} />
                        <Route exact path="/Feedback" element={<Feedback />} />
                        <Route exact path="/FeedbackGrid" element={<FeedbackGrid />} />
                        <Route exact path="/AddFeedback" element={<AddFeedback />} />
                        <Route exact path="/indivigualfeedbackgrid" element={<IndivigualFlagFeedbackGrid />} />
                        <Route exact path="/HrApproveFeedback" element={<HrApproveFeedback />} />
                        <Route exact path="/goaltemplateform" element={<GoalTemplateForm />}></Route>
                        <Route exact path="/goaltemplateform/:templateId" element={<GoalTemplateForm />}></Route>
                        {/* <Route exact path={'/todo'} element={<Todo />}></Route> */}
                        <Route exact path={'/concerns'} element={<ConcernsGrid />}></Route>
                        <Route exact path={'/concernForm'} element={<ConcernForm />}></Route>
                        <Route exact path={`/concernView`} element={<ConcernView />}></Route>
                        <Route exact path={`/faq`} element={<FAQList />}></Route>
                        <Route exact path={`/addfaq`} element={<FAQForm />}></Route>
                        {/* Dashboard */}
                        <Route exact path="/Overview" element={<Overview />} />
                        <Route exact path="/teamdashboard/" element={<TeamMemberDashboard />} />
                        <Route exact path="/moodgrid" element={<MoodGrid />} />
                        <Route exact path="/announcements" element={<AnnouncementBlog />} />
                        <Route exact path="/empappreciation" element={<AppreciationBlog />} />
                        <Route exact path="/goaltemplateform" element={<GoalTemplateForm />}></Route>
                        <Route exact path="/goaltemplateform/:templateId" element={<GoalTemplateForm />}></Route>
                        <Route exact path="/goaltemplate" element={<TemplateData />}></Route>
                        <Route exact path="/appreciation" element={<Appreciation />}></Route>
                        <Route exact path="/appreciationform" element={<AppreciationForm />}></Route>
                        <Route exact path="/appreciationform/:appreciationId" element={<AppreciationForm />}></Route>
                        <Route exact path="/profileupdate" element={<ProfileUpdate />}></Route>

                        {encryptStorage.getItem('grc') || encryptStorage.getItem('secAudits') || encryptStorage.getItem('groupid') == 1 ? (
                            <Route exact path="/policyform" element={<FormPolicy />}></Route>
                        ) : (
                            <></>
                        )}
                        {encryptStorage.getItem('grc') || encryptStorage.getItem('groupid') == 1 ? (
                            <Route exact path="/PolicyDirectory" element={<PolicyDirectory />} />
                        ) : (
                            <></>
                        )}

                        {encryptStorage.getItem('grc') || encryptStorage.getItem('groupid') == 1 ? (
                            <Route exact path="/individualpolicydetail" element={<IndividualPolicyDirectory />}></Route>
                        ) : (
                            <></>
                        )}

                        <Route exact path="/policy" element={<ManagePolicy />}></Route>

                        {/* <Route exact path="/policy" element={<Policy />}></Route> */}
                        {/* <Route exact path="/policyform" element={<PolicyForm />}></Route> */}
                        {/* <Route exact path="/policyform/:policyId" element={<PolicyForm />}></Route> */}
                        <Route exact path="/touchbase" element={<Touchbase />}></Route>
                        <Route exact path="/touchbaseform" element={<TouchbaseForm />}></Route>
                        <Route exact path="/touchbaseform/:touchbaseId" element={<TouchbaseForm />}></Route>
                        <Route exact path="/touchbasefeedback/:touchbaseId" element={<TouchbaseFeedbackForm />}></Route>
                        <Route exact path="/performance" element={<Performance />}></Route>
                        <Route exact path="/goalform" element={<GoalForm />}></Route>
                        <Route exact path="/goalform/:goalId" element={<GoalForm />}></Route>
                        <Route exact path="/goalview/:goalId" element={<GoalView />}></Route>
                        <Route exact path="/performanceevaluation" element={<PerformanceEvaluation />}></Route>
                        <Route exact path="/NotificationCall/:NotificationId" element={<NotificationCall />} />
                        <Route exact path="/offboardingForm" element={<Offboarding />} />
                        <Route exact path="/offboardingGrid" element={<OffboardingGrid />} />
                        <Route exact path="/HrOffboardingGrid" element={<HrOffboardingGrid />} />
                        <Route exact path="/Recruitment/CandidateView" element={<CandidateOverview />} />
                        <Route exact path="/Recruitment/AddJobs" element={<JobPosting />} />
                        <Route exact path="/Recruitment/Jobs" element={<JobInformation />} />
                        <Route exact path="/Recruitment" element={<JobsLanding />} />
                        <Route exact path="/Onboarding" element={<Onboarding />} />
                        <Route exact path="/OfferLetter" element={<OfferLetter />} />
                        <Route exact path="/leaveform" element={<LeaveForm />}></Route>
                        <Route exact path="/leaveform/:leaveId" element={<LeaveForm />}></Route>
                        <Route exact path="/leavewfh" element={<Wfh />}></Route>
                        <Route exact path="/wfhform" element={<WfhForm />} />
                        <Route exact path="/wfhform/:wfhId" element={<WfhForm />} />
                        <Route exact path="/TeamDirectory" element={<TeamDirectory />} />
                        <Route exact path="/ProfileContainer" element={<ProfileContainer />} />
                        <Route exact path="/AddressDetail" element={<AddressDetail />} />
                        <Route exact path="/EducationDetail" element={<EducationDetail />} />
                        <Route exact path="/CertificateDetails" element={<CertificateDetails />} />
                        <Route exact path="/BankDetails" element={<BankDetails />} />
                        <Route exact path="/PassportDetail" element={<PassportDetail />} />
                        <Route exact path="/PreviousEmploymentDetails" element={<PreviousEmploymentDetails />} />
                        <Route exact path="/SkillDetails" element={<SkillDetails />} />
                        <Route exact path="/DependentDetails" element={<DependentDetails />} />
                        <Route exact path="/Profile" element={<Profile />} />
                        <Route exact path="/EmployeeInfo" element={<EmployeeInfo />} />
                        <Route exact path="/SalaryRevisionGrid" element={<SalaryRevisionGrid />} />
                        <Route exact path="/OnboardingDetails" element={<OnboardingDetails />} />
                        <Route exact path="/SalaryRevision" element={<SalaryRevision />} />
                        <Route exact path="/OffboardingGrid" element={<OffboardingGrid />} />
                        <Route exact path="/Feedback" element={<Feedback />} />
                        <Route exact path="/FeedbackGrid" element={<FeedbackGrid />} />
                        <Route exact path="/AddFeedback" element={<AddFeedback />} />
                        <Route exact path="/HrApproveFeedback" element={<HrApproveFeedback />} />
                        <Route exact path="/teamdashboard/" element={<TeamMemberDashboard />} />
                        <Route exact path="/moodgrid" element={<MoodGrid />} />
                        <Route exact path="/managecertifications" element={<AdminCertifications/>} />
                        <Route exact path="/certifications" element={<CertificationList/>} />
                        <Route exact path='/usercertification' element ={<EmployeeCertifications/>} />
                        <Route path="/finance-management" element={<FinanceManagement/>} />
                        <Route exact path="/Session" element={<SessionOverview />} />
                        <Route path = "/participants/:sessionId/:slotId" element={<SessionParticipants />}/>

                        {centcomManageRole == '1' ? <Route exact path="/centcom" element={<Grid />} /> : <></>}
                        {/* <Route path="dashboard/activities" element={<Activities/>} /> */}
                        {/* <Route path="/Recruitment/CandidateView" element={<CandidateOverview />} />
                        <Route path="/Recruitment/AddJobs" element={<JobPosting />} />
                        <Route path="/Recruitment/Jobs" element={<JobInformation />} />
                        <Route exact path="/Recruitment" element={<JobsLanding />} />
                        <Route exact path="/Onboarding" element={<Onboarding />} /> */}
                        <Route exact path="/holidaylist" element={<HolidayList />} />
                        <Route path="*" element={<ErrorPage />} />
                    </Routes>
                    {window.location.pathname !== '/' && window.location.pathname !== '/hivelogin' ? <Footer /> : null}
                </div>
            )}
            {!isLoginPage && timeoutPopup && ( // Conditional rendering for popup
  <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog goal-popup-per modal-dialog-centered" style={{ maxWidth: '666px' }}>
      <div className="modal-content px-5">
        <div className="modal-body text-center py-4">
          <img src="/Images/Honeybee.svg" alt="honeybee-img" className="honeybee-img" />
          <p className="bold-text font-18 text-blue my-5">
            Your Session has been timed out due to inactivity. Please login again into the application.
          </p>
          <div className="text-center d-flex justify-content-center">
            <button className="btn hive-btn-primary bold-text font-14" type="button" onClick={handleLogout}>Ok</button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
        </div>
    );
}

function sendNotification(message, user) {
    const notification = new Notification('Hive', {
        icon: hiveLogo,
        body: `${message} By @${user}`,
    });
}

export function checkPageStatus(message, user = 'Jagan') {
    if (!window.Notification) {
    } else {
        // check if permission is already granted
        // if (Notification.permission === 'granted') {
        if (window.Notification.permission === 'granted') {
            sendNotification(message, user);
        } else {
            // request permission from user
            window.Notification.requestPermission()
                .then(function (p) {
                    if (p === 'granted') {
                        sendNotification(message, user);
                    } else {
                        sendNotification(message, user);
                        //
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        }
    }
}

function mapStateToProps(state) {
    return {
        websocketAPI: state.websocket,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setWebSocket: (websocket) => dispatch(setWekSocket(websocket)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
